//RRD
import { Link, useLocation } from "react-router-dom";
//
//Bottom Menu Icons
import UserIcon from "../../../styles/icon/menu/User.svg";
import UserFillIcon from "../../../styles/icon/menu/User_fill.svg";
import WalletIcon from "../../../styles/icon/menu/Wallet_light.svg";
import WalletFillIcon from "../../../styles/icon/menu/wallet-fill.svg";
import TradeIcon from "../../../styles/icon/menu/Chart.svg";
import TradeFillIcon from "../../../styles/icon/menu/Chart-fill.svg";
import HomeIcon from "../../../styles/icon/menu/home.svg";
import HomeFillIcon from "../../../styles/icon/menu/home-fill.svg";
import ChangeIcon from "../../../styles/icon/menu/Vertical_switch.svg";
//
//Styles
import styles from "./BottomCrypto.module.scss";
import { useSelector } from "react-redux";
//
export default function BottomCrypto() {
  const appTheme = useSelector((state) => state.appTheme);
  const { pathname } = useLocation();

  return (
    <div
      className={`${styles.BottomMenu} ${
        appTheme === "dark" ? styles.dark : ""
      }`}
    >
      <Link to="/my-profile">
        <div className={styles.menu_item}>
          <div className={styles.item_icon}>
            <img
              className="convertPicToGreen"
              src={pathname === "/my-profile" ? UserFillIcon : UserIcon}
              alt="wallet"
              width="25"
              height="25"
            />
          </div>
          <div className={styles.item_title}>پروفایل</div>
        </div>
      </Link>
      <Link to="/my-wallet">
        <div className={styles.menu_item}>
          <div className={styles.item_icon}>
            <img
              className="convertPicToGreen"
              src={pathname === "/my-wallet" ? WalletFillIcon : WalletIcon}
              alt="wallet"
              width="25"
              height="25"
            />
          </div>
          <div className={styles.item_title}>کیف پول</div>
        </div>
      </Link>
      <div className={styles.menu_item}>
        <Link to="/convert">
          <div className={`${styles.item_icon} ${styles.item_icon_change}`}>
            <img src={ChangeIcon} alt="Change" width="30" height="30" />
          </div>
        </Link>
        <div className={styles.item_title_change}>تبدیل</div>
      </div>
      <Link to="/trades-list">
        <div className={styles.menu_item}>
          <div className={styles.item_icon}>
            <img
              className="convertPicToGreen"
              src={pathname === "/trades-list" ? TradeFillIcon : TradeIcon}
              alt="trade"
              width="25"
              height="25"
            />
          </div>
          <div className={styles.item_title}>خرید و فروش</div>
        </div>
      </Link>
      <Link to="/">
        <div className={styles.menu_item}>
          <div className={styles.item_icon}>
            <img
              className="convertPicToGreen"
              src={pathname === "/" ? HomeFillIcon : HomeIcon}
              alt="home"
              width="25"
              height="25"
            />
          </div>
          <div className={styles.item_title}>خانه</div>
        </div>
      </Link>
    </div>
  );
}
